import React from "react";
import { Link } from "react-router-dom";
import TourPackageData from "./TourPackageData";
import { Helmet } from "react-helmet";

export const TourPackageList = () => {
    return (
        <>
            <Helmet>
                <title>India Tour & Travel Services – One Way Cab, Sightseeing, Hotel Stays</title>
                <meta
                    name="description"
                    content="Hire a cab in Jaipur for sightseeing, weekend getaways, and family tours. We offer reliable outstation taxi service across Rajasthan & North India."
                />
                <meta
                    name="keywords"
                    content="India tour packages, Rajasthan taxi service, Jaipur sightseeing, weekend getaways, family tours, one way cab, outstation taxi, taxi service Rajasthan, North India travel"
                />
            </Helmet>

            <div className="px-6 py-10">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-3xl font-bold font-sans text-gray-800">
                        Tour Package from Jaipur
                    </h3>
                    <Link to="/packages" className="text-pink-500 font-medium hover:underline">
                        See All
                    </Link>
                </div>

                <div className="space-y-6 p-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                        {TourPackageData.slice(0, 5).map((city, index) => (
                            <Link key={index} to="/packages">
                                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-transform duration-300 hover:scale-105 p-3 text-center border-2 border-pink-200 hover:bg-pink-200">
                                    <img src={city.image} alt={city.title} className="w-full h-40 object-cover rounded-md" />
                                    <h3 className="text-xl font-semibold text-gray-900 mt-3">{city.title}</h3>
                                    <p className="text-gray-600 text-sm mt-1">Tour Package</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}